// extracted by mini-css-extract-plugin
export default {"disclaimer":"Disclaimer_disclaimer__f93kf","alertIcon":"Disclaimer_alertIcon__eMqTh"};